import { put } from 'redux-saga/effects'
import { push } from 'connected-react-router';
import UserApi from "../services/userApi";
import {
    INIT_APP_FAIL, VARIFY_OTP_RESPONSE, VARIFY_OTP_RESPONSE_FAIL,
    MENU_ROLE_WISE_RESPONSE, MENU_ROLE_WISE_RESPONSE_FAIL,
    MASTER_MENU_RESPONSE, MASTER_MENU_RESPONSE_FAIL

} from '../redux/types/initApp'; //POPUP_MENU_RESPONSE, POPUP_MENU_RESPONSE_FAIL Code removed for DXTech issue

let api = new UserApi();

export function* initApp({ type, resolve, payload }) {
    let responsePayload = {};

    try {

        let { data } = yield api.init(payload);

        if (data?.success) {
            // let response = data?.data?.pmsProducts;
            // responsePayload.pmsList = formatPMSList(response);
            // yield put({ type: INIT_APP_RESPONSE, payload: responsePayload })

            resolve && resolve()
        }

    } catch (e) {
        yield put({ type: INIT_APP_FAIL })
    }
}

export function* varifyOtp({ type, resolve, payload }) {
    let responsePayload = {};
    try {
        let { data } = yield api.verifyOtp(payload);
        if (data?.success) {
            yield put(push('/dashboard'));
            responsePayload = data.data;
            yield put({ type: VARIFY_OTP_RESPONSE, payload: responsePayload })

            resolve && resolve()
        }
    } catch (e) {
        yield put({ type: VARIFY_OTP_RESPONSE_FAIL })
    }
}

export function* menuRoleWise({ type, resolve, payload }) {
    let responsePayload = {};
    let List = [];
    try {
        let { data } = yield api.menuRoleWise(payload);
        if (data?.success) {

            responsePayload = data.data;

            yield put({ type: MENU_ROLE_WISE_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }

    } catch (e) {
        //  yield put(push('/'));
        yield put({ type: MENU_ROLE_WISE_RESPONSE_FAIL })
        resolve && resolve(e)

    }
}

export function* masterMenu({ type, resolve, payload }) {
    let responsePayload = {};
    let List = [];

    try {
        let { data } = yield api.masterMenu();
        if (data?.success) {
            responsePayload = data.data;
            yield put({ type: MASTER_MENU_RESPONSE, payload: responsePayload })
            resolve && resolve(responsePayload)
        }
    } catch (e) {
        yield put({ type: MASTER_MENU_RESPONSE_FAIL })
        resolve && resolve(e)
    }
}
// Utils

//SA Changes made for handling Popup --Abhishek
//SA Code commented for DXTech issue
// export function* popupmenu({ type, resolve, payload }) {
//     let responsePayload = {};   
//     try {
//         let { data } = yield api.popupmenu(payload);
//         if (data?.success) {
//             responsePayload = data.data;
//             yield put({ type: POPUP_MENU_RESPONSE, payload: responsePayload })
//             resolve && resolve(responsePayload)
//         } else {
//             yield put({ type: POPUP_MENU_RESPONSE_FAIL,payload:data })
//             resolve && resolve(data)
//         }
//     } catch (e) {
//         yield put({ type: POPUP_MENU_RESPONSE_FAIL,payload:e })
//         resolve && resolve(e)
//     }
// }
//EA Code commented for DXTech issue
//EA Changes made for handling Popup --Abhishek

function formatPMSList(data) {
    let processedList = data.map(({ pms_Code, instrument_Name }) => {
        return { label: instrument_Name, value: pms_Code }
    })
    return processedList;
}